<div class="dialog-wrapper">
  <div class="c-dialog-content">
    <p class="c-dialog-text mb-12-px mt-unset">You are trying to search parts for this vehicle, if you want to proceed,
      please add it to your saved vehicles:</p>
    <div class="vehicles">
      <div class="vehicle">
        <div class="content pr-8-px">
          <img [src]="
                    vehicleModification?.images?.url100
                      ? vehicleModification?.images?.url100
                      : './../../../../assets/images/vehicles/vehicles-basic-placeholder.svg'
                  " alt="vehicle-img" />
          <p class="vehicle-description">
            {{ vehicleModification?.manufacturer?.name }} {{ vehicleModification?.model?.name }}
            {{ vehicleModification?.name }}
            <span class="years"><b>{{ vehicleModification?.period }}</b></span>
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="c-dialog-actions">
    <button (click)="cancelSuggestedVehicle()" pButton pRipple class="c-button light cancel">Cancel</button>
    <button (click)="addVehicleToMySavedList()" pButton pRipple class="c-button primary save">Save & Proceed</button>
  </div>
</div>
